"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConferencePlatform = void 0;
var ConferencePlatform;
(function (ConferencePlatform) {
    ConferencePlatform["ZOOM"] = "ZOOM";
})(ConferencePlatform = exports.ConferencePlatform || (exports.ConferencePlatform = {}));
//# sourceMappingURL=service-schedule-policy.dto.js.map